// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"dd0cf57e","21":"21f953fe","110":"0859e2e2","228":"213287c9","317":"61e51654","471":"d1dbc6c2","478":"03ffe689","479":"a98209c5","485":"d7cb16de","647":"9b617ca9","662":"3379f81f","769":"86b80522"}[chunkId] + ".chunk.js";
};